export const ROUTES = {
  LOGIN: '/login',
  LOGIN_CALLBACK: '/login/callback',
  SIGNUP: '/signup',

  // Dashboard
  DASHBOARD: '/dashboard',
  
  // Shipments
  SHIPMENTS: '/shipments',
  SHIPMENTS_NEW: '/shipments/new',
  SHIPMENTS_EDIT: '/shipments/:id/edit',
  SHIPMENTS_DETAIL: '/shipments/:id',
  
  // Inventory
  INVENTORY: '/inventory',
  INVENTORY_NEW: '/inventory/new',
  INVENTORY_EDIT: '/inventory/:id/edit',
  INVENTORY_DETAIL: '/inventory/:id',
  
  // Contracts
  CONTRACTS: '/contracts',
  CONTRACTS_SALE: '/contracts/sale',
  CONTRACTS_BUY: '/contracts/buy',
  CONTRACTS_PERFORMANCE: '/contracts/performance',
  CONTRACTS_NEW: '/contracts/new',
  CONTRACTS_DETAIL: '/contracts/:id',
  
  // Clearing
  CLEARING: '/clearing',
  CLEARING_DETAIL: '/clearing/:id',
  
  // Storage
  STORAGE: '/storage',
  STORAGE_WAREHOUSES: '/storage/warehouses',
  STORAGE_MOVEMENTS: '/storage/movements',
  
  // Load Out
  LOAD_OUT: '/load-out',
  LOAD_OUT_NEW: '/load-out/new',
  LOAD_OUT_DETAIL: '/load-out/:id',
  
  // Order Fulfillment
  ORDER_FULFILLMENT: '/order-fulfillment',
  ORDER_FULFILLMENT_NEW: '/order-fulfillment/new',
  ORDER_FULFILLMENT_DETAIL: '/order-fulfillment/:id',
  
  // Vendors
  VENDORS: '/vendors',
  VENDORS_NEW: '/vendors/new',
  VENDORS_EDIT: '/vendors/:id/edit',
  VENDORS_DETAIL: '/vendors/:id',
  
  // Payments
  PAYMENTS: '/payments',
  PAYMENTS_NEW: '/payments/new',
  PAYMENTS_DETAIL: '/payments/:id',
  
  // Finance
  FINANCE_OVERVIEW: '/finance/overview',
  FINANCE_CASH_FLOW: '/finance/cash-flow',
  FINANCE_INVOICES: '/finance/invoices',
  FINANCE_PURCHASES: '/finance/purchases',
  FINANCE_PRODUCTS_SERVICES: '/finance/products-services',
  FINANCE_OPERATIONAL_COSTS: '/finance/operational-costs',
  FINANCE_SNAPSHOT: '/finance/snapshot',
  FINANCE_ANALYTICS: '/finance/analytics',
  
  // Reports
  REPORTS: '/reports',
  REPORTS_SHIPMENTS: '/reports/shipments',
  REPORTS_INVENTORY: '/reports/inventory',
  REPORTS_PAYMENTS: '/reports/payments',
  
  // Documents
  DOCUMENTS: '/documents',
  
  // Users
  USERS: '/users',
  USERS_NEW: '/users/new',
  USERS_EDIT: '/users/:id/edit',
  
  // Notifications
  NOTIFICATIONS: '/notifications',

  // Phase 3: AI Actions (pending recommendations)
  AI_ACTIONS: '/ai-actions',
  
  // Settings
  SETTINGS: '/settings',
  SETTINGS_GENERAL: '/settings/general',
  SETTINGS_INTEGRATIONS: '/settings/integrations',
  SETTINGS_NOTIFICATIONS: '/settings/notifications',
  SETTINGS_USER_MANAGEMENT: '/settings/user-management',
} as const

